import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import api from "../lib/api";
import { devError } from "../lib/devLog";

const SettingsCtx = createContext(null);

const DEFAULTS = {
  brand_name: "GOSHI",
  logo_url: "",
  hero_image: "",
  hero_eyebrow: "FW Collection 2026",
  hero_title_line_1: "Quiet luxury,",
  hero_title_line_2: "sculpted in shadow.",
  hero_cta_label: "Discover the Collection",
  about_image: "",
  about_eyebrow: "The House",
  about_title: "Garments cut to outlast the season.",
  about_body: "",
  cta_image: "",
  cta_eyebrow: "Members Only",
  cta_title: "Receive 10% off your first edit.",
  cta_subtitle: "Use code GOSHI10 at checkout.",
  cta_coupon_code: "GOSHI10",
  contact_email: "support@goshifashion.com",
  contact_phone: "",
  contact_address: "By appointment",
  instagram_url: "https://www.instagram.com/goshi__official?igsh=a2RxbzYyYnBwaHQx",
  footer_tagline: "A women's atelier devoted to quiet luxury.",
  meta_pixel_id: "",
  clarity_id: "",
  sender_email: "",
  admin_notification_email: "",
  brand_name: "",
};

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings({ ...DEFAULTS, ...data });
    } catch (e) {
      devError("Failed to load settings:", e);
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const save = useCallback(async (patch) => {
    const { data } = await api.put("/settings", patch);
    setSettings({ ...DEFAULTS, ...data });
    return data;
  }, []);

  const value = useMemo(() => ({ settings, loaded, refresh, save }), [settings, loaded, refresh, save]);
  return <SettingsCtx.Provider value={value}>{children}</SettingsCtx.Provider>;
}

export const useSettings = () => useContext(SettingsCtx);
